import * as styles from "./DogSearch.module.scss";

import { Button, Form } from "../../../../components/common";

import { navigate } from "gatsby";
import React from "react";
import { Add } from "../../../../components/common/Icons";
import LoadingIndicator from "../../../../components/common/LoadingIndicator/LoadingIndicator";
import { useDogSearchApi } from "../../../../context";
import { isSpecificSite } from "../../../../utils/isSpecificSite";
import LocationInput from "../../LocationInput/LocationInput";

export interface DogSearchProps {
	stackInputs?: boolean;
	isHomepage?: boolean;
}

const trackFilters = (data: Record<string, unknown>) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ ...data });
};

//! Any changes in this file may need to be replicated in ./FilterPanel.tsx
export const DogSearch: React.FC<DogSearchProps> = ({
	stackInputs = false,
	isHomepage = false,
}) => {
	isSpecificSite("uk", "DogSearch");
	const {
		currentDistance,
		resultsCount,
		selectedBreeds,
		searchListingsUrl,
		dogApiLoading,
		userLocation,
		onChangeFilterView,
		onUpdateLocation,
	} = useDogSearchApi();

	const showDogsButtonText = !dogApiLoading
		? `Show ${resultsCount} dog(s)`
		: "Loading...";

	return (
		<div
			className={`${styles.dogsearch} ${isHomepage ? styles.leftalign : ""}`}
		>
			<div
				className={styles.loadingoverlay}
				style={{
					display: dogApiLoading ? "flex" : "none",
				}}
			>
				<div className={styles.loadingbackground} />
				<div className={styles.loadingicon}>
					<LoadingIndicator loading={dogApiLoading} scale={1.5} />
				</div>
			</div>
			<h2 className={styles.title}>Find dogs to adopt</h2>
			<div
				className={
					stackInputs ? styles.filteroptionsstacked : styles.filteroptions
				}
			>
				<div
					className={
						stackInputs ? styles.filteroptionstacked : styles.filteroption
					}
				>
					<Form onSubmitFn={() => {}} validationSchema={{}}>
						<label htmlFor="postcode" className={styles.label}>
							Postcode
						</label>
						<LocationInput
							className={styles.searchinput}
							name={"postcode"}
							onClearUserLocation={() => onUpdateLocation(null, 1000)}
							userLocation={userLocation}
							onConfirmUserLocation={(location) =>
								onUpdateLocation(
									location,
									currentDistance > 150 ? 150 : currentDistance,
								)
							}
							placeholder={"All of UK"}
							placeTypes={["locality", "sublocality", "postal_code"]}
						/>
					</Form>
				</div>
				<div
					className={
						stackInputs ? styles.filteroptionstacked : styles.filteroption
					}
				>
					<span className={styles.label}>Breed</span>
					<button
						type="button"
						className={styles.breedorlocationselector}
						onClick={() => onChangeFilterView("Breeds")}
					>
						{selectedBreeds.length > 0 ? (
							<>
								<div className={styles.breedtext}>
									<div>Breeds selected</div>
									<div className={styles.breedselectedcount}>
										{selectedBreeds.length}
									</div>
								</div>
								<div className={styles.addbreedsicon}>+</div>
							</>
						) : (
							<>
								<div className={styles.breedtext}>Any</div>
								<div className={styles.addbreedsicon}>
									<Add />
								</div>
							</>
						)}
					</button>
				</div>
			</div>
			<Button
				key={"show-dogs-button"}
				className={styles.showdogsbutton}
				// url={searchListingsUrl} // REMOVED THIS
				fullWidth={true}
				isLoading={dogApiLoading}
				onClick={() => {
					trackFilters({
						event: "rehoming_search",
						rehoming_breed: selectedBreeds.toString(), // dog breed selected, comma separated list for multiple selections
					});
					navigate(searchListingsUrl); // URL IS CALLED HERE AFTER TRACKING NOW
				}}
				disabled={dogApiLoading || resultsCount === 0}
			>
				{showDogsButtonText}
			</Button>
			<button
				type="button"
				className={styles.viewmore}
				style={{ fontWeight: isHomepage && 600 }}
				onClick={() => onChangeFilterView("Any")}
				tabIndex={0}
				onKeyDown={(e) => e.key === "Enter" && onChangeFilterView("Any")}
			>
				View more filters
			</button>
		</div>
	);
};

export default DogSearch;
